<footer class="text-lg-start">
  <div *ngIf="showTopFooter" class="top-footer">
    <!-- Grid container -->
    <div class=" container p-4">
      <!--Grid row-->
      <div class="row">

        <!--Grid column-->
        <div class="col-lg-3 col-md-6 mb-3 mb-lg-0">
          <img src="./assets/images/abeyga_logos/abeyga_lg_200.jpg" alt="Abeyga logo ">
          
        </div>
        <!--Grid column-->        
        <div class="col-lg-3 col-md-6 mb-3 mb-lg-0">
          <img src="./assets/images/abeyga_logos/Erasm_Cofund_200.jpg" alt="Erasmus Cofunding logo ">
          
        </div>
        <div class="col-lg-3 col-md-6 mb-3 mb-lg-0">
          <img src="./assets/images/abeyga_logos/Erasmus_p.png" alt="Erasmus Plus logo ">
          
        </div>
        <div class="col-lg-3 col-md-6 mb-3 mb-lg-0">
          <img src="./assets/images/abeyga_logos/inedivim_lg_200.jpg" alt="INEDIVIM logo ">
          
        </div>
      </div>
      <!--Grid row-->

      <div class="row mt-2">
       <div class="m-0 mx-auto">
        AbeyGa by <img src="./assets/images/abeyga_logos/OpenUp_logo200.png" alt="OpenUp logo ">
      
       
        <a href="http://www.openup.gr/"> OpenUp</a> Greek Scientific Association of Innovation, copyright <span>&copy;</span> 2022
       </div>

      </div> <!-- My row -->

    </div>
  </div>
  <!-- Grid container -->

  <!-- Copyright -->
  <div class="bottom-footer p-1 d-flex justify-content-center align-items-center text-white">
    <div class="content-container">
      <p class="m-0">
        <a class="text-white"
           href="http://www.dspace.org/">{{ 'footer.link.dspace' | translate}}</a>
        {{ 'footer.copyright' | translate:{year: dateObj | date:'y'} }}
        <a class="text-white"
           href="https://www.lyrasis.org/">{{ 'footer.link.lyrasis' | translate}}</a>
      </p>
      <ul class="footer-info list-unstyled small d-flex justify-content-center mb-0">
        <li>
          <a class="text-white" href="javascript:void(0);"
             (click)="showCookieSettings()">{{ 'footer.link.cookies' | translate}}</a>
        </li>
        <li>
          <a class="text-white"
             routerLink="info/privacy">{{ 'footer.link.privacy-policy' | translate}}</a>
        </li>
        <li>
          <a class="text-white"
             routerLink="info/end-user-agreement">{{ 'footer.link.end-user-agreement' | translate}}</a>
        </li>
        <li>
          <a class="text-white"
             routerLink="info/feedback">{{ 'footer.link.feedback' | translate}}</a>
        </li>
      </ul>
    </div>
  </div>
  <!-- Copyright -->
</footer>
